import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { whatsappLink } from "../data/services";

const NAV = [
  { to: "/", label: "Inicio" },
  { to: "/firma", label: "Firma" },
  { to: "/servicios", label: "Servicios" },
  { to: "/mision-vision", label: "Misión & Visión" },
  { to: "/contacto", label: "Contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const transparent = !scrolled && location.pathname === "/";

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        transparent
          ? "bg-transparent border-b border-white/10"
          : "bg-white/95 backdrop-blur-md border-b border-slate-200"
      }`}
    >
      <div className="container-x flex items-center justify-between h-20">
        <Logo variant={transparent ? "light" : "dark"} />

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase().replace(/s|&/g, "")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide under-gold transition-colors ${
                  transparent
                    ? isActive
                      ? "text-white"
                      : "text-white/80 hover:text-white"
                    : isActive
                    ? "text-navy-900"
                    : "text-slate-600 hover:text-navy-900"
                }`
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-cta-whatsapp"
            className={`text-sm font-medium px-5 py-2.5 rounded-sm transition-all ${
              transparent
                ? "border border-white/40 text-white hover:bg-white hover:text-navy-900"
                : "bg-navy-900 text-white hover:bg-navy-800"
            }`}
          >
            Agendar consulta
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menú"
          data-testid="navbar-mobile-toggle"
          className={`lg:hidden p-2 rounded-sm ${
            transparent ? "text-white" : "text-navy-900"
          }`}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="navbar-mobile-panel"
          className="lg:hidden bg-white border-t border-slate-200 shadow-lg"
        >
          <nav className="container-x py-6 flex flex-col gap-1">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-mobile-${item.label.toLowerCase().replace(/s|&/g, "")}`}
                className="py-3 text-base font-medium text-slate-700 hover:text-navy-900 border-b border-slate-100 last:border-0"
              >
                {item.label}
              </Link>
            ))}
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="navbar-mobile-cta"
              className="mt-4 w-full text-center bg-navy-900 text-white py-3 rounded-sm font-medium"
            >
              Agendar consulta
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}